import di from "di";
import FindTickerFeed from 'common/gql/query/store/ticker/FindTickerFeed.gql'

import TickerSource from '../enum/TickerSource';
import tickerSourceUrlFilter from '../filter/tickerSourceUrl';

export const TickerStoreAction = {
    LOAD_FEED: "LOAD_FEED",
    POPULATE_FEEDS: "POPULATE_FEEDS",
};

export const TickerStoreMutation = {
    ADD_FEED: "ADD_FEED"
};

function createEmptyState() {

    return {
        feeds: {}
    };
}

export const tickerStore = {

    state() {

        return createEmptyState();
    },

    getters: {

        getFeed: state => source => {

            return state.feeds[source];
        }
    },

    mutations: {

        clear(state) {
            Object.assign(state, createEmptyState());
        },

        [TickerStoreMutation.ADD_FEED](state, {source, data}) {
            state.feeds[source] = data;
        }
    },

    actions: {

        async [TickerStoreAction.LOAD_FEED](ctx, source) {

            const apollo = di.get('apollo');
            const auth = di.get('auth');

            //NOTE: This doesnt need to exist, because otherwise the screens will not work with the ticker
            // if (!auth || !auth.session) {
            //     return;
            // }

            const token = auth?.session?.token;
            const results = await apollo.query({
                query: FindTickerFeed,
                variables: {source},
                context: {
                    headers: {
                        Authorization: token ? `Bearer ${token}` : ''
                    }
                }
            });

            const tickerItems = results.data?.findTickerFeed;

            ctx.commit(TickerStoreMutation.ADD_FEED, {
                source,
                data: tickerItems
            });

            return tickerItems;
        },

        async [TickerStoreAction.POPULATE_FEEDS](ctx) {

            const sources = Object.keys(TickerSource).filter(source => !!tickerSourceUrlFilter(source));

            for (let source of sources) {

                try {
                    await ctx.dispatch(TickerStoreAction.LOAD_FEED, source);
                } catch (e) {
                    // Ignore
                }
            }
        }
    }
};
